module.exports = __webpack_public_path__ + "static/media/play_store.c68e1c2f.svg";